import GuaranteedRentPage from "@/pages/guaranteed-rent/GuaranteedRentPage";
import { getCity } from "@/pages/guaranteed-rent/cityConfig";

export default function GuaranteedRentStockport() {
  return <GuaranteedRentPage city={getCity("stockport")} />;
}